export enum UserRole {
  Admin = 'Admin',
  SuperAdvisor = 'SuperAdvisor',
  Advisor = 'Advisor',
  User = 'User',
  Deleted = 'Deleted',
  RelativeUserAccount = 'RelativeUserAccount',
  Developer = 'Developer',
}
